import withMatcher from '#/utils/withMatcher';
import { ISearchState, TSearchSelected } from '../reducers/search';

export const createActionSearchSetItems = withMatcher(
  (
    payload: Omit<ISearchState, 'query' | 'selected' | '_loading' | '_error'>
  ) => {
    return {
      type: 'search/set_items',
      payload,
    };
  }
);

export const createActionSearchSetTrackFavorite = withMatcher(
  (payload: { track: string; favorite: boolean }) => {
    return {
      type: 'search/set_track_favorite',
      payload,
    };
  }
);

export const createActionSearchStartLoading = withMatcher(() => {
  return {
    type: 'search/start_loading',
  };
});

export const createActionSearchStopLoading = withMatcher(() => {
  return {
    type: 'search/stop_loading',
  };
});

export const createActionSearchError = withMatcher((error: boolean) => {
  return {
    type: 'search/set_error',
    payload: error,
  };
});

export const createActionSearchSetSelected = withMatcher(
  (payload: TSearchSelected) => {
    return {
      type: 'search/set_selected',
      payload,
    };
  }
);

export const createActionSearchSetQuery = withMatcher((payload: string) => {
  return {
    type: 'search/set_query',
    payload,
  };
});

export const createActionSearchReset = withMatcher(() => {
  return {
    type: 'search/reset',
  };
});
